import $ from "jquery";
import Constants from "../business/Constants";
import GigyaManager from "../business/GigyaManager";
import RestManager from "../business/RestManager";
import { SmartComponent } from "smart-component-js";
import moment from "moment";
import productData from "../data/product";
import storeOffline from "../data/store_offline";
import storeOnline from "../data/store_online";

class AreaPersonaleCtrl extends SmartComponent {
  constructor(element, parentComponent, params) {
    super(element, parentComponent, params);
    this.init();
  }
  init() {
    this.loadChildComponents(this);
    this.startLoader();

    if (
      moment(Constants.CLOSING_STEP_1_DATE, "DD/MM/YYYY HH:mm").diff(moment()) <
      0
    ) {
      $(".closingStep1").show();
    } else {
      $(".beforeClosing").show();
    }

    GigyaManager.getLoggedUserCached().then(
      (u) => {
        let name = u.profile.firstName;
        let gender = u.profile.gender;
        let msg = $(".custom-msg");
        if (gender === "f") {
          $(msg).html("Benvenuta " + name);
        } else if (gender === "m") {
          $(msg).html("Benvenuto " + name);
        } else {
          $(msg).html("Ciao " + name);
        }

        $("#receipt_number").html(0);

        RestManager.userStatus().then(
          (data) => {
            let plays = data.response.data.receipts;

            $(".recap-cnt").html("");

            let hasRequestPrize = false;

            for (var i = plays.length - 1; i >= 0; i--) {
              let play = plays[i];

              if (play.status == "WIN") {
                play.wininfo = data.response.data.winstatus.info;
                $(".recap-cnt").append(this.buildReceiptTemplate(play));
              }
            }

            let win = data.response.data.winstatus.info;

            if (win.winner) {
              $("#receipt_number").html(1);
              if (win.prizerequested) {
                $(".edit-content").html(
                  `<p>Complimenti, hai vinto la<strong> gift card FINIPER da 50€</strong> e richiesto il tuo premio.<br/> 
                  Stiamo controllando la tua partecipazione e il tuo documento di acquisto. <br/>
                  Appena effettuata la verifica il tuo premio sarà spedito all’indirizzo che ci hai comunicato.</p> <br/>
                  <p>Per avere informazioni relative alla consegna consulta la sezione <a href="/promozioni/dona-felicita-a-colazione-finiper/faq-e-contatti">Faq e Contatti</a></p>.
                  <a class="button more-padding" href="javascript:void(0);" component-click="goToPlayReceipt()">Gioca scontrino</a>`
                );
                this.loadChildComponents(this);
              } else {
                $(".edit-content").html(
                  `<p>Complimenti, hai vinto la<strong> gift card FINIPER da 50€</strong>.<br/> Richiedi il tuo premio e compila tutti i campi necessari per la spedizione.</p>
                  <a class="button more-padding" href="javascript:void(0);" component-click="goToPlayReceipt()">Gioca scontrino</a>`
                  //<p>Hai già giocato il tuo scontrino telefonicamente e hai vinto?<br /><a href="/promozioni/dona-felicita-a-colazione-finiper/associa-numero">Associa numero</a></p>
                );
                this.loadChildComponents(this);
              }
            }
            this.removeLoader();
          },
          (data) => {
            this.removeLoader();
            if (data) {
              let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                    <div class="feedback__modal__wrap">
                                                        <div class="feedback__modal__close" component-click="close()">
                                                            <svg>
                                                                <use xlink:href="#svg_circle_close"></use>
                                                            </svg>
                                                        </div>
                                                        <div class="feedback__modal__content">
                                                            <h2 class="h3">Ops, qualcosa è andato storto!</h2>
                                                            <p>${data.status.errors.data.description}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                               `;
              $(this.element).append(tmplModalGeneric);
              this.loadChildComponents(this);
            }
          }
        );
      },
      (err) => {
        window.location.href =
          "/login?urlBack=" +
          window.location.href.replace(window.location.origin, "") +
          "&regSource=" +
          Constants.PROMO_CODE;
      }
    );
  }

  goToPlayReceipt() {
    //TODO Mettere blocco orario!
    window.location.href =
      "/promozioni/dona-felicita-a-colazione-finiper/gioca-scontrino";
  }

  buildReceiptTemplate(obj) {
    let mm_play_date = moment(obj.date, "YYYY-MM-DD hh:mm:ss");
    let mm_receipt_date = moment(
      `${obj.playdata.year}-${obj.playdata.month}-${obj.playdata.day}`,
      "YYYY-MM-DD"
    );
    mm_play_date.locale("it");
    mm_receipt_date.locale("it");
    let html = `
            <div class="recap-row ${obj.status == "WIN" ? "done" : ""}">
                <div class="recap-row-content">
                    <span class="recap-date">${mm_play_date.format(
                      "LL"
                    )}</span><br/>
                    Scontrino del <span class="recap-date-scontrino">${mm_receipt_date.format(
                      "LL"
                    )}</span><br/>
                    Totale <strong>&euro; <span class="recaptotal">${
                      obj.playdata.euros
                    },${obj.playdata.cents}</span></strong>
                </div>
                ${this.printFeedback(obj)}
            </div>
        `;
    return html;
  }

  printFeedback(obj) {
    const { playdata, wininfo, status } = obj;
    const qs = `pt=${playdata.token}&pm=${obj.interface == "Web" ? "1" : "3"}`;
    const preizeRequested = wininfo && wininfo.prizerequested;
    const hasBeenSent = wininfo.shipment_date !== "";
    const STATUS = wininfo.winstatus.admindata.status;

    // DISCLAIMER
    let disclaimerCopy = "";
    const disclaimers = {
      default:
        "L’eventuale vincita sarà confermata solo dopo i controlli previsti come da Regolamento",
      traceSpedition: `Puoi seguire la spedizione del tuo pacco&nbsp;<a href="${wininfo.shipment_link}" target="_blank">qui</a>`,
      server: wininfo.winstatus.admindata.description,
    };

    switch (STATUS) {
      //CONFERMATA che a sua volta può essere intesa come:
      case 1:
        // - RICHIESTA(in attesa che l'ordine vengo recepito dal corriere)
        if (hasBeenSent) disclaimerCopy = disclaimers.traceSpedition;
        // - SPEDITA(ordine ricevuto e spedito dal corriere)
        else disclaimerCopy = disclaimers.server;
        break;
      //NON CONFERMATA
      case 0:
        disclaimerCopy = wininfo.winstatus.admindata.description;
        break;
      default:
        disclaimerCopy = disclaimers.default;
        break;
    }

    const evaluateFeedback = (() => {
      if (
        preizeRequested &&
        (STATUS === "" || (STATUS !== 0 && STATUS !== 1))
      ) {
        //Premio richiesto ma non ancora verificato
        return `<span class="content-feedback col50">
                      Hai già richiesto il tuo premio
                      <span class="disclaimer">${disclaimerCopy}</span>
                </span>`;
      } else if (STATUS === 1 && preizeRequested) {
        //Se il premio è stato spedito
        return hasBeenSent
          ? //Traccia pacco
            `<span class="content-feedback col50">
                          Premio spedito il ${wininfo.shipment_date}
                          <span class="disclaimer">${disclaimerCopy}</span>
            </span>`
          : //Vincita confermata
            `<span class="content-feedback col50">
                              <span>${disclaimerCopy}</span>
                              <span class="disclaimer">Il tuo premio è in fase di preparazione</span>
                            </span>`;
      } else if (STATUS === 0) {
        //Vittoria non confermata
        return `<span class="content-feedback col50 lose">
                       <span class="disclaimer">${disclaimerCopy}</span>
                </span>`;
      } else {
        //Richiedi premio
        return `<span class="content-feedback col50">
                  Hai vinto la gift card FINIPER da 50€
                  <span class="disclaimer">${disclaimerCopy}</span>
                </span>
                <a class="button button__yellow more-padding" href="/promozioni/dona-felicita-a-colazione-finiper/completa-dati?${qs}">
                  Richiedi premio
                </a>`;
      }
    })();

    // FEEDBACK
    let html = `<div class="recap-row-feedback ${
      !preizeRequested ? "space-around" : ""
    }">${evaluateFeedback}</div>`;

    return status == "WIN" || status == "FINAL" ? html : "";
  }

  removeLoader() {
    $(".tool_loader").fadeOut(500).remove();
    $("body").removeClass("noScroll");
  }

  startLoader() {
    $(".mb-finiper-felicita2020").append(
      '<div data-tool-loader="" class="tool_loader"><svg><use xlink:href="#svg_loader"></use></svg></div>'
    );
    $("body").addClass("noScroll");
  }
}

export default AreaPersonaleCtrl;
